import { APP_ENDPOINT, ASSET_PREFIX } from "utils/constants";
import Link from 'next/link';
import { useRouter } from "next/router";
import PropTypes from 'prop-types';

const SocialOption = {
  facebook: {
    icon: `${ASSET_PREFIX}/images/account/referrals/facebook.svg`,
    href: (link) => `https://www.facebook.com/dialog/share?app_id=256975402191022&display=popup&href=${encodeURIComponent(link)}`
  },
  whatsapp: {
    icon: `${ASSET_PREFIX}/images/account/referrals/whatsapp.svg`,
    href: (link) => `whatsapp://send?text=${encodeURIComponent(`${link}`)}`
  },
  email: {
    icon: `${ASSET_PREFIX}/images/account/referrals/email-icon.svg`,
    href: (link, subject) => `mailto:?subject=${encodeURIComponent(`${subject}`)}&body=${encodeURIComponent(`${link}`)}`
  },
  linkedin: {
    icon: `${ASSET_PREFIX}/images/account/referrals/linkedin.svg`,
    href: (link) => `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(link)}`
  },
};

const SocialOptions = Object.keys(SocialOption);

const SocialReferralButtons = ({ emailSubject }) => {
  const router = useRouter();
  const link = `https://${APP_ENDPOINT}${router.asPath.split('?')[0]}`;

  return (
    <div className='container'>

      { SocialOptions.map(id => {
        const option = SocialOption[id];
        return (
          <Link key={id} href={ option.href ? option.href(link, emailSubject) : '#' }>
            <a target='_blank' className='option'>
              <img src={ option.icon } />
            </a>
          </Link>
        );
      })}

      <style jsx>{ `
      .container {
        display: flex;
        justify-content: space-between;
      }
      
      .option {
        margin: 0 0.5em;
        line-height: 0;
        cursor: pointer;
      }
      
      .option img {
        margin: 0.6em auto;
        height: 30px;
        filter: brightness(30%) saturate(100%);
      }
    ` }</style>
    </div>
  );
};

SocialReferralButtons.propTypes = {
  emailSubject: PropTypes.string,
};

SocialReferralButtons.defaultProps = {
  emailSubject: 'Check out this DAYMADE prize!',
};

export default SocialReferralButtons;
